/* Old Ajaxify.js.liquid */

/*============================================================================

==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
const speedfly_version = "4-5-2";
/*============================================================================
  API Helper Functions
==============================================================================*/

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.   
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}
/*
Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};
*/
/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
  
/*============================================================================
# TOOLS
==============================================================================*/


Shopify.reloadDesignMode = function(events, fn) {
  events.forEach(function(event) {
    document.addEventListener(event, function() {
      setTimeout(function(){   
        console.log(event);
        fn();
      }, 500); 
    }, false);
  });
}

Shopify.simulateLink = function() {
  let gridImages = document.querySelectorAll('.simulate-link');
  for (let i = 0; i < gridImages.length; i++) {       
    gridImages[i].addEventListener('click', function() {
      let link = gridImages[i].dataset.link;     
      window.location.href = link;        
    });
  }
}    

Shopify.simulateLink();   

Shopify.mailtoFormater = function(){
  var regEx = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/;

  $(".site-footer p").filter(function() {
    return $(this).html().match(regEx);
  }).each(function() {
    $(this).html($(this).html().replace(regEx, "<a href=\"mailto:$1\">$1</a>"));
  });
}

document.addEventListener("DOMContentLoaded", function() { 
  Shopify.mailtoFormater();  
});

/*============================================================================
# HEADER
==============================================================================*/

Shopify.onSticky = function(lvl) {

  let stickyElement = document.querySelector('.header-section');
  let parent;
  stickyElement.classList.add('sticky');
  if( lvl === 2) {
    parent = stickyElement.parentElement.parentElement;
  } else {
    parent = stickyElement.parentElement;
  } 
};

if (window.matchMedia("(max-width: 750px)").matches) {
  Shopify.onSticky(2);
}
 
/*============================================================================
# PRODUCT
==============================================================================*/

Shopify.ZoomImage = function() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    $(document).on('mousemove', '.frame', function(event) {

      var element = {
        width: $(this).width(),
        height: $(this).height()
      };

      var mouse = {
        x: event.pageX,
        y: event.pageY
      };

      var offset = $(this).offset();

      var origin = {
        x: (offset.left + (element.width / 2)),
        y: (offset.top + (element.height / 2))
      };

      var trans = {
        left: (origin.x - mouse.x) / 2,
        down: (origin.y - mouse.y) / 2
      };

      var transform = ("scale(2,2) translateX(" + trans.left + "px) translateY(" + trans.down + "px)");

      $(this).children(".zoom").css("transform", transform);

    });
    $(document).on('mouseleave', '.frame', function() {
      $(this).children(".zoom").css("transform", "none");
    });

  } else {

    // Sélectionne l'image et ajoute un événement au clic
    const imagesZoom = document.querySelectorAll('.product-photo-container .zoom-mobile');

    function generateDom(imageZoom) {
      // Crée une div pour le conteneur de l'image
      const container = document.createElement('div');
      container.classList.add('modal-container-image');

      // Crée une image pour la modal
      const modalImage = document.createElement('img');
      modalImage.src = imageZoom.src;
      modalImage.srcset = imageZoom.srcset;
      modalImage.alt = imageZoom.alt;
     
      modalImage.style.width = imageZoom.width * 1.5;
      modalImage.style.height = imageZoom.height * 1.5;

      // Crée un bouton pour fermer la modal
      const closeButton = document.createElement('button');
      closeButton.innerHTML = '&times;';
      closeButton.addEventListener('click', () => {
        container.remove();
      });

      // Ajoute l'image et le bouton au conteneur
      container.appendChild(modalImage);
      container.appendChild(closeButton);

      // Ajoute le conteneur juste en dessous de l'image
     
      document.querySelector('.main-content').insertBefore(container, document.querySelector('.main-content').firstChild);
    }
    imagesZoom.forEach(imageZoom => {
      imageZoom.parentNode.addEventListener('click', (event) => {
      generateDom(imageZoom);
      });
    });
  }
}
if(document.querySelector('.product-photo-container.zoom')) {
  Shopify.ZoomImage();
}

Shopify.formDesign = function () {
  
 const forms  = document.querySelectorAll('.form-primary');  
 
  if(forms.length) {

    forms.forEach(form => {
      if(form.getAttribute("data-product-form-layout") == "2") {
        
        let selector = ".swatch .header";
        
      
        if(document.querySelectorAll(selector)) {

          if(form.getAttribute("data-product-form-number") == "true") {

          setTimeout(function() {
            let variantsCount = document.querySelectorAll(selector);        
            if(variantsCount.length > 0) {
              $(selector).each(function(index) {             
                let content = $(this).text();
                $(this).html(`<span class="header-number">${index + 1}</span>${content} : `);
                
              });
            }
            let contentQty = $('.product-form-layout-2 .quantity-selector').eq(0).text();
            $('.product-form-layout-2 .quantity-selector').html(`<span class="header-number">${variantsCount.length + 1}</span>${contentQty} : `);

          }, 1000)

        } 
        }
      } 
    });
   
  } 
}

Shopify.formDesign();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.formDesign);

Shopify.deliveryDate = function () {
  const containers = [...document.querySelectorAll(".delivery-date")];

  if(containers.length === 0) return

  const container = containers[0];
  let firstDate = container.dataset.deliveryDateFrom;
  let lastDate = container.dataset.deliveryDateTo;
  let isDeliverySaturday = container.dataset.deliveryDateSaturday ? true : false;

  let fromDateTimestamp = new Date().getTime() + 24 * firstDate * 3600 * 1000,      
  fromDateDay = new Date(fromDateTimestamp).getDate(),
  fromDateMonth = new Date(fromDateTimestamp).getMonth() + 1,
  toDateTimestamp = new Date().getTime() + 24 * lastDate * 3600 * 1000,
  toDateDay = new Date(toDateTimestamp).getDate(),       
  toDateMonth = new Date(toDateTimestamp).getMonth() + 1; 

  fromDateMonth = (fromDateMonth < 9 ? '0' : '') + fromDateMonth;
  toDateMonth = (toDateMonth < 9 ? '0' : '') + toDateMonth; 

  const checkIfWe = day => {   
    if(new Date(fromDateTimestamp).getDay() === 6) {
      if(day === 1) {       
        fromDateDay = fromDateDay;
        toDateDay = toDateDay + 1;    
      } else {
        fromDateDay = fromDateDay + 2;
        toDateDay = toDateDay + 3;    
      }
    }   
  } 

  isDeliverySaturday ? checkIfWe(1) : checkIfWe(2);   

  document.getElementById("ddFromDate").innerHTML =`${fromDateDay}/${fromDateMonth}`;
  document.getElementById("ddToDate").innerHTML =`${toDateDay}/${toDateMonth}`;  
  container.style.display = 'flex';
}

Shopify.deliveryDate();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.deliveryDate);

/*============================================================================
# PRODUCT LIST
==============================================================================*/
Shopify.modalForm = function(id) { 
  
  const section = document.querySelector('.featured-collection');
  if(!section) return;
  
  const productsforms = document.querySelectorAll('.grid-product-form');
  const allModals = document.querySelectorAll('.modal-form');
  
  const reset = (elem) => {
    allModals.forEach(function(modal) {      
      modal.classList.remove('show-modal-form');
    }); 
  }

  if(productsforms.length > 0) {
    productsforms.forEach((elem) => {   
    callback(elem); 
    
    });
  }
	
  section.addEventListener('mouseleave', function() {
    setTimeout(() => {
      reset();
    }, 300);
  }); 
  

  function callback(elem) {
  
    const modalForm = elem.querySelector('.modal-form');
    // const sel = elem.querySelector('select');
    const productWrapperBtn = elem.querySelector('.btn');
    const btnClose = elem.querySelector('.modal-form--close');
    const btnAtc = elem.querySelector('.addToCart');   
   
    /*sel.addEventListener('change', function(e) {
      sel.nextElementSibling.click();
    });*/

    ['click'].forEach(function(event) {     
      productWrapperBtn.addEventListener(event, function(e) {
        reset();
        modalForm.classList.add('show-modal-form');
        modalForm.style = "block";  
      });
    
    });

    btnAtc.addEventListener('click', function() {
      setTimeout(() => {
        reset();
      }, 1500);  
    }); 

    btnClose.addEventListener('click', function() {
      setTimeout(() => {
        reset();
      }, 300);
    }); 
    
  } 
  
}

Shopify.modalForm();

Shopify.collectionUtils = function(id) {  

  const collections = document.querySelectorAll('.featured-collection');
  if(collections.length > 0) {
    collections.forEach((collection) => {
    let section = collection.querySelector('.section-collection');
    callback(section.id); 
    });
  }

  function callback(id) {

    let section = document.getElementById(id); 
    let gridTitlesCrop = document.querySelectorAll(`#${id} .grid-crop-title`);
    let gridTitles = document.querySelectorAll(`#${id} .title-truncate`);
    let gridHeight = section.getAttribute('data-title-height');
    let gridHeightSm = section.getAttribute('data-title-height-sm');
    let titleTruncate = section.getAttribute('data-title-truncate');
    let titleTruncateSm = section.getAttribute('data-title-truncate-sm');
    function truncateString(str, num) {

      if (str.length <= num) {
        return str
      }

      return str.slice(0, num) + '...'
    }

    for(i = 0; i < gridTitles.length; i++) {
      let textTitle = gridTitles[i].textContent;
      let num;
      if(window.matchMedia("(min-width:768px)").matches) {
        num = titleTruncate;
      } 
      else {
        num = titleTruncateSm;
      }
      gridTitles[i].textContent = truncateString(textTitle, num);     
    }

    for(i = 0; i < gridTitlesCrop.length; i++) {
      let titleHeight = gridTitlesCrop[i];
      if(window.matchMedia("(min-width:768px)").matches) {       
        titleHeight.style.minHeight = gridHeight+'px';
      } 
      else {
        titleHeight.style.minHeight = gridHeightSm+'px';
      }   
    }
  }  
}

Shopify.collectionUtils();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.collectionUtils);

/*============================================================================
# COMPONENTS
==============================================================================*/

/* Generique */

const shopifyHeader = document.getElementById('shopify-section-header');
const shopifyAside = document.querySelector('.sidebar');

// if(shopifyAside) shopifyAside.style.top = shopifyHeader.offsetHeight+"px";

Shopify.readMore = function() {
  const divs = document.querySelectorAll('.read-more');
  if(divs.length === 0) {
    return
  }
  divs.forEach(div => {
    let btn = document.createElement('button');
    btn.textContent = "En savoir plus"; 
    btn.classList.add('btn','btn-primary','read-more-btn','btn--small');
    let parent = div.parentNode; 
    parent.insertBefore(btn, div);
    btn.addEventListener('click', function() {      
      div.classList.toggle('show');
      btn.classList.toggle('active');
      if(div.classList.contains('show')) {
        btn.textContent = "En savoir moins";
      } else {
        btn.textContent = "En savoir plus"; 
      }
    });    
  });
}

Shopify.readMore();

Shopify.accordion = function(a, p, opt) {
  const faqs = document.querySelectorAll('.faq');
  const acc = document.querySelectorAll('.panel-heading');
  const panel = document.querySelectorAll('.panel-collapse');

  if (!faqs.length) {
    return;
  }
  
  for (let i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {      
      let setClasses = !this.classList.contains("active");
      setClass(acc, "active", "remove");
      setClass(panel, "in", "remove");  
      if (setClasses) {
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("in");
      }
    };
  }
  
  const setClass = (els, className, fnName) => {
    for (let i = 0; i < els.length; i++) {
      if(!opt) els[i].classList[fnName](className);
    }
  }  
};

Shopify.accordion();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.accordion);
  
Shopify.accordeonMobile = function(selector, opacity) {
  const panelTitles = document.querySelectorAll(selector);
  for (let i = 0; i < panelTitles.length; i++) {
    const panelTitle = panelTitles[i];
    panelTitle.classList.add("accordeon-panel-title");
    const addChevron = '<i class="fa fa-chevron-down"></i>';
    panelTitle.insertAdjacentHTML('beforeend', addChevron);
    const panelContent = panelTitles[i].nextElementSibling;
    panelContent.classList.add("accordeon-panel-hidden");
    panelTitle.addEventListener("click", function() {    
      panelContent.classList.toggle("accordeon-panel-show");    
      panelTitle.classList.toggle("accordeon-open"); 
    });
  }
}

if (window.matchMedia("(max-width: 600px)").matches) {
    
} 

/* Product */

function quantitySelector() {
 
  const qtyInputs = document.querySelectorAll('.template-product .custom-selector-qty .quantity-selector, .featured-product .custom-selector-qty .quantity-selector');
  if(qtyInputs.length === 0) return
  const btnsAtc = document.querySelectorAll('.btn-atc');
  qtyInputs.forEach(input => {if(btnsAtc.length > 0) 
    if(btnsAtc.length > 0) input.style.height = btnsAtc[0].offsetHeight - 2 +'px'; 
    input.previousElementSibling.addEventListener('click', (e) => {       
      input.value =  parseInt(input.value) > 1 ? parseInt(input.value) - 1 : 1;      
    });
    input.nextElementSibling.addEventListener('click', (e) => {       
      input.value = parseInt(input.value) + 1;   
    });
  });  

}

quantitySelector();

const serialize = (data) => {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
}

Shopify.addProduct = function (formsClass, btnClass) {

  let forms = document.querySelectorAll(formsClass);

  if(!forms.length > 0) return

  forms.forEach(form => {
    let btns = form.querySelectorAll(btnClass);
    btns.forEach(btn => {
    btn.addEventListener('click', (e) => {      
      e.preventDefault();
        addItem(form);
      });
    });
  })

  const addItem = async (form) => {

    data = new FormData(form);
    let formObj = serialize(data);
    var properties = {};

    Object.keys(formObj).forEach(key => {
      if(key.includes('properties')) {  
        Object.assign(properties, {[key]: formObj[key]});
      }
    });
  
    let addData = {
      'id':formObj.id,
      'quantity':formObj.quantity,
      'properties': properties
    };

    await fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
        let message;
        console.log(json)


        if(json.status === 422) {
          console.log('erreur panier');
       
        setTimeout( async () => {
          document.querySelector('.cart-message-error').classList.add('errors');
          if(Shopify.locale === "fr") {
            message = "Désolé, stock insuffisant";
          } else {
            message = "Sorry, no sufficient stock";
          }
            document.querySelector('.cart-message-error').textContent =  message;
            setTimeout( async () => {
              document.querySelector('.cart-message-error').classList.remove('errors');
              document.querySelector('.cart-message-error').textContent = ""
            }, 3000);
            
        }, 1000);
       }
       
    }).catch(function(err) {
      console.error(err)     
    });
  }
  
}



Shopify.addProduct('.addToCartForm','.btn-atc');


Shopify.productTabs = function () {
  
  const links = document.querySelectorAll('.tabs__menu li');
  const contents = document.querySelectorAll('.tab__content');
  
  // Permet d'afficher ou masquer le contenu
  toggle = (targetId) => {
   
    // si l'identifiant de lien est le même que l'id du contenu alors on lui rajoute le display block sinon on masque
    contents.forEach(elem=>{
     
      elem.style.display = elem.id === targetId ? 'block' : 'none';
      // On va recibler le lien associé et on lui ajoute la class active et on la retire aux autres
      document.querySelector(`[data-target="${elem.id}"]`).classList[elem.id === targetId ? 'add' : 'remove']('is-active');
    })
  }
  
  // on liste des tabsList
  links.forEach((link) => {
    // Au click on appelle la fonction toggle en lui passant l'id de l'élement cliqué
    link.addEventListener('click', (e) => {
      e.preventDefault();
      toggle(link.dataset.target);
    }); 
    // au chargement on vérifie quel élément est actif
    if(link.className.includes('is-active')){
      toggle(link.dataset.target);
    }
  });
};

Shopify.productTabs();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.productTabs);

/* Article */

Shopify.Summary = function() {
  const t = "Sommaire";
  const h = ".rte h2, .rte h3";
  const nb = "3";

  function slugify(str)
{
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '') 
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-') 
    // Collapse dashes
    .replace(/-+/g, '-'); 

    return str;
}

  const wrapper = document.querySelector('.summary');
  if(!wrapper) {
    return;
  }
  const titles = document.querySelectorAll(h);
 
  if (titles.length <= nb) {
    wrapper.style.display = "none";
    return          
  }
  
  let arrayTitles = [];  
  let i;
  // on boucle pour ajouter des ids différents et récupérer le texte des titres              
  for(i=0; i < titles.length; i++){
    const title = titles[i];
    const slug = slugify(title.textContent);
    title.id = `${slug}`;
    arrayTitles.push({
      tag: title.tagName,
      title: title.textContent
    });         
  }              
  // on crée le sommaire    
  const summaryWrapper = document.createElement('div');
  summaryWrapper.id = "summary";          
  const summaryTitle = document.createElement('strong');
  summaryTitle.textContent = t;
  summaryWrapper.appendChild(summaryTitle);
  const btnClose = document.createElement('button');
  btnClose.innerHTML = `<i class="fa fa-bars"></i>`;
  btnClose.classList.add("btn-close");
  summaryWrapper.appendChild(btnClose);
  const ul = document.createElement('ul');
  ul.classList.add("summary-list");
  summaryWrapper.appendChild(ul);
  // on récupère le texte des titres et on crée la liste à puce
  for(i=0; i < arrayTitles.length; i++){            
    const linkTitle = arrayTitles[i].title;                 
    const addLi = document.createElement('li');        
    const insertLi = ul.appendChild(addLi);
    const createLink = document.createElement('a');
    const hrefSlug = slugify(linkTitle);
    createLink.href = `#${hrefSlug}`;            
    const insertLink = insertLi.appendChild(createLink);
    if(arrayTitles[i].tag === "H2") {
      insertLink.innerHTML = `${linkTitle}`; 
    } else {
      insertLink.innerHTML = `<span style="padding-left:1rem;font-size:12px;">${linkTitle}</span>`; 
    }
  }
 
  wrapper.append(summaryWrapper); 

  const links = document.querySelectorAll('.summary .summary-list a');
  const headerHeight = document.querySelector('.header-wrapper').clientHeight;
  let id, title, titleHeight;
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      id = link.href.split('#');
      title = document.getElementById(id[1]);
      if (window.matchMedia("(max-width: 749px)").matches) {
        titleHeight = title.offsetTop - 15;
      } else {
       titleHeight = title.offsetTop + title.offsetHeight;
      }     
      window.scroll({
        top: titleHeight,     
        behavior: 'smooth'
      });
    });
  });

  btnClose.addEventListener('click', function() {
    ul.classList.toggle('hide');
  });   
}

Shopify.Summary();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.Summary);

Shopify.productsInsideArticle = function() { 
  const findAllProductsOnArticle = document.querySelectorAll('[data-product-handle]');
  const url = "https://speedfly-theme.myshopify.com/";

  const createProductForm = (item, product) => {
    let wrapper = document.createElement('div');
    let title = document.createElement('div');

    wrapper.classList.add('component-product-rte');
    title.classList.add('component-product-rte__title');
    
    item.appendChild(wrapper);
    wrapper.innerHTML = `
    <img src="${product.image.src}" style="max-height:100px;" loading="lazyload" alt="" />
    <div class="component-product-rte__title">${product.title}</div>
    <a href="/products/${product.handle}" class="btn btn-primary">Voir le produit</a>
    `;   
  }

  const getProduct = async (item, handle) => {
    await fetch(`${url}/products/${handle}.json`)
      .then(res => res.json())
      .then((data) => {
      createProductForm(item, data.product);
    }).catch(err => console.error(err));
  }
  
  findAllProductsOnArticle.forEach(item => {
    getProduct(item, item.dataset.productHandle);
  });
};


if(document.querySelector('.template-article')) Shopify.productsInsideArticle();

/* cart */

 

/* Mini-cart */

class MiniCart extends HTMLElement {
  constructor() { 
    super();
    this.modal = document.querySelector(".mini-cart-modal");
    this.modalOverlay = document.querySelector(".mini-cart-modal-overlay");
    this.container = document.getElementById("mini-cart__v2");
    this.btns = document.querySelectorAll('form[action="/cart/add"] .btn-atc');
    this.cartCount = document.querySelectorAll('.cart-count');
    this.cartToggle = document.querySelectorAll('.cart-toggle');
    this.footerBtns = document.querySelector(".mini-cart-btns");
    this.handleAddProduct();
    this.handleClickCartIcon();
    this.ifCartTemplate = document.querySelectorAll('.template-cart');  
  } 

  openModal() { 

    setTimeout( async () => {
    this.modalOverlay.classList.add("open");
    this.modal.classList.add("open");
    this.container.classList.add("visible");
    }, 300);
  }

  closeModal() {
    
    this.modalOverlay.classList.remove("open");
    this.modal.classList.remove("open");  
    this.container.classList.remove("visible");
    
  }

  handleClickCloseModal() { 
    let btnClose = document.getElementById("mini-cart-close-modal");
    btnClose.addEventListener('click', (e) => {       
      this.closeModal();
    });
    this.modalOverlay.addEventListener('click', (e) => {       
      this.closeModal();
    });
  }

  generateDom(data) {

    const $container = this.container;
    const itemsContainer = $container.querySelector('.mini-cart__items');  
    itemsContainer.innerHTML = '';
    $container.querySelector('.mini-cart__footer-subTotal').innerHTML = '';
    $container.querySelector('.mini-cart__footer-totalDiscount').innerHTML = '';

    if(data.item_count === 0) { 
      this.footerBtns.style.display = "none";  
      itemsContainer.innerHTML = `<span style="font-weight:bold">Votre panier est vide.</span>`; 
      this.cartCount[0].classList.add('hidden-count');     
      this.cartCount[1].classList.add('hidden-count');  
    } else {
      this.footerBtns.style.display = "flex";  
    }
    
    // add header
    $container.querySelector('.mini-cart__header').innerHTML = `
    <div class="h3 mb-none">Panier <span class="cart-count">${data.item_count}</span></div>
    <button id="mini-cart-close-modal"><i class="fa fa-times"></i></button>
    `      
    // add items   

    data.items.forEach((item, index) => {

      let div = document.createElement('div');
      div.classList.add('mini-cart__item');
      div.dataset.variantId = item.variant_id;
      div.dataset.price = item.final_price;
      div.dataset.line = index + 1;
     
      let img = document.createElement('img');
      img.src = item.image;
      img.width = "55";
      img.height = "55";
      div.appendChild(img);      

      let divTitle = document.createElement('div')
      divTitle.textContent = `${item.title}`;

      divTitle.classList.add('mini-cart__item-title');
      itemsContainer.appendChild(div);
      div.appendChild(divTitle);

      let divQty = document.createElement('div')
      divQty.classList.add('custom-selector-qty');
      itemsContainer.appendChild(divQty);
      div.appendChild(divQty);
      divQty.innerHTML = `<span class="custom-selector-qty--minus">-</span></button><input type="number" name="qty" id="qty" min="1" data-line="${index + 1}" value="${item.quantity}" /><span class="custom-selector-qty--add">+</span>`;

      let divPrices = document.createElement('div')
      if (item.discounts.length > 0) {
        divPrices.innerHTML = `<span>${Shopify.formatMoney(item.final_price, moneyFormat)}</span><br /><small style="font-weight:bold"> ${item.discounts[0].title}</small>`;
      } else {
        divPrices.innerHTML = `<span>${Shopify.formatMoney(item.final_price, moneyFormat)}</span>`;
      }
     
      divPrices.classList.add('mini-cart__item-prices');
      divPrices.dataset.price = item.final_price;
                
      itemsContainer.appendChild(divPrices);
      div.appendChild(divPrices);

      let btn = document.createElement('button');
      btn.classList.add('mini-cart__remove-item');
      btn.innerHTML = '&times;';
      
      div.appendChild(btn);      
      
    })    
   
    if(data.item_count > 0) { 
      this.cartCount[0].classList.remove('hidden-count');
      this.cartCount[0].textContent = data.item_count;
      this.cartCount[1].textContent = data.item_count;
    }

    this.handleChangeQty(data.total_price);
    this.handleClickCloseModal();
    
    // add footer  
    if(data.total_price > 0) {
      $container.querySelector('.mini-cart__footer-subTotal').innerHTML = `<div>Sous-total: <span>${Shopify.formatMoney(data.total_price, moneyFormat)}</span></div>`;
    }
    if(data.total_discount > 0) {
      $container.querySelector('.mini-cart__footer-totalDiscount').innerHTML = `<div>Economisez : <span>${Shopify.formatMoney(data.total_discount, moneyFormat)}</span></div>`;  
    }   
  }

  getItems() {
    setTimeout( async () => {
      await fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        this.generateDom(data);
      });
    }, 300);
  }

  updateQty(input, inputParent, direction) {
    const all = document.querySelectorAll('.mini-cart__item');   
      
    input.nextElementSibling.addEventListener('click', (e) => {  
      if(parseFloat(inputParent.nextElementSibling.dataset.price) > 0) { 
        input.value = parseInt(input.value) +1;
        this.updateItemQty(input.value, input.dataset.line);
      }
    });
    input.previousElementSibling.addEventListener('click', (e) => {  
      if(parseFloat(inputParent.nextElementSibling.dataset.price) > 0) { 
        input.value = parseInt(input.value) -1;
        this.updateItemQty(input.value, input.dataset.line);        
      }
    });    
  }

  handleChangeQty(cartTotalPrice) {
    const qtyInputs = this.container.querySelectorAll('.custom-selector-qty input');  
    const btns = this.container.querySelectorAll('.mini-cart__remove-item');
 
    let inputParent;

    qtyInputs.forEach(input => {
     
      inputParent = input.parentNode;
      this.updateQty(input, inputParent);
    });

    btns.forEach(btn => {     
      btn.addEventListener('click', (e) => {
        return this.updateItemQty(0, btn.parentNode.dataset.line);
        console.log(btn.parentNode.dataset.line);
      });      
    });

    /* if goodies */
    if(document.getElementById('benefits')) {
      document.getElementById('benefit-cart-total').dataset.cartTotal = cartTotalPrice > 0 ? cartTotalPrice.toString().slice(0, -2) : 0;
      goodies();
    }
  
  }

  async updateItemQty(quantity, line){    

    const body = JSON.stringify({
      line,
      quantity      
    });
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }, ...{ body }
      }).then(function (data) {
        if (!data.status == 200) {
          console.error('Request returned an error', data)
        }
      })
    .catch(function (error) {
      console.error('Request failed', error)
    });

    this.getItems();    
  }

  handleAddProduct() {
    this.btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setTimeout(() => {
          this.getItems();
          this.openModal();
        }, 1000);
      });
    })
  }

  handleClickCartIcon() {
    this.cartToggle.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        // console.log(this.ifCartTemplate);
        if(this.ifCartTemplate.length > 0) { location.reload() } ;
        this.getItems();
        this.openModal();      
       });
    })    
  }     
}

customElements.define('mini-cart', MiniCart);

/* Cart Upsells */
Shopify.productUpsell = function() { 
 
  const upsells = [...document.querySelectorAll('.product__upsell')]
  let ifCartTemplate = document.querySelectorAll('.template-cart');  

  if(!upsells.length === 0) return;

  upsells.forEach(upsell => {
    let form = upsell.querySelector('form'); 
    let img = upsell.querySelector('img')
    let select = upsell.querySelector('select');    
    let btn = upsell.querySelector('button'); 
    callback(select, img);
    handleClick(btn, upsell);
  })  

  function callback(select, img) {
    select.addEventListener('change', (e) => {      
      const [option] = e.target.selectedOptions
      img.src = option.dataset.imgsrc;
    });   
  }

  function handleClick(btn, upsell) {
    btn.addEventListener('click', () => { 
      upsell.style.display = "none";
      if(upsell.closest('.mini-cart-product')) {
        upsell.closest('.mini-cart-product').querySelector('.product__upsells').style.display = "none";
      }
    
      if(ifCartTemplate.length > 0) setTimeout(() => { location.reload() }, 1000);
    });
  }
  
};

Shopify.productUpsell();

/*============================================================================
# SLIDERS - SLICK
==============================================================================*/
Shopify.SlideshowMoveArrow = function() {
  let moveBtn = document.querySelector('.movearrow');
  if(moveBtn) {
    setTimeout(function() {        
      let sliderHeight = document.querySelector(".slider-section").offsetHeight();
      moveBtn.addEventListener('click', function() { 
        window.scroll({
          top: sliderHeight,     
          behavior: 'smooth'
        });
      });
    }, 1000);
  }   
}

Shopify.SlideshowMoveArrow();

Shopify.sliderFlashInfos = function() {

  const slider = document.querySelector('.flash-infos');
  
  if(!slider) return

  let autoPlaySpeed = slider.dataset.autoPlaySpeed;
  let nbDesktop = 1;
  let nbMobile = 1;

  jQuery(slider).not('.slick-initialized').slick({
    dots: false,
    infinite: true,
    speed: 300,    
    arrows: false,    
    autoplay: true,
    autoplaySpeed: autoPlaySpeed,
    slidesToShow: nbDesktop,
    slidesToScroll: nbDesktop,
    arrows: false,
    responsive: [          
      {
        breakpoint: 900,
        settings: {
          slidesToShow: nbDesktop,
          slidesToScroll: nbDesktop
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: nbMobile,
          slidesToScroll: nbMobile
        }
      }          
    ]
  });
}

Shopify.sliderFlashInfos();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.sliderFlashInfos);

Shopify.slider = function() {

  function callbackSlider(id, settings) {
 
    jQuery('#'+id).not('.slick-initialized').slick({ 
      infinite: true,
      slidesToShow: settings.nbDesktop,
      slidesToScroll: 1,
      adaptiveHeight: false,
      dots: false,   
      lazyLoad: "progressive",              
      speed: 300,     
      responsive: [   
        {
          breakpoint: 900,
          settings: {
            slidesToShow: settings.nbDesktop,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: settings.nbDesktop,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: settings.nbMobile,
            slidesToScroll: 1,        
            centerMode: settings.centerMode,
            centerPadding: '25px'
          }
        }     
      ]  
    });
  }
  const sliders = document.querySelectorAll('.product-list-slider');
  if(sliders.length > 0) {
    sliders.forEach((slider) => {
      let params = slider.getAttribute('data-slider');
   
      const settings = JSON.parse(params);
      callbackSlider(slider.id, settings)
    });
  }
}

Shopify.slider();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.slider);

Shopify.productSlider = function () {
  
  const slider = document.querySelector('.slider-product');

  if(slider) {
    
    const thumbnails = document.querySelector('.slider-product-thumbnails');
    const thumbnailsLayout = parseInt(slider.getAttribute('data-thumbnails-layout'));
    let thumbnailsNumber = parseInt(slider.getAttribute('data-thumbnails-number'));
  
    if(thumbnailsNumber == "0" || isNaN(thumbnailsNumber)) {   
      thumbnails.style.display = "none";     
      thumbnailsNumber = "1";
    }
    
    jQuery(slider).not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,    
      asNavFor: thumbnails, 
      pauseOnFocus:false,
      speed: 100,
      lazyLoad: "progressive",
      fade: true,
      cssEase: 'linear'
    });

    if (thumbnailsLayout == "1") {
      jQuery(thumbnails).not('.slick-initialized').slick({
        slidesToShow: thumbnailsNumber,
        slidesToScroll: thumbnailsNumber,
        asNavFor: slider,
        dots: true,
        infinite:false,       
        centerMode: false, 
        focusOnSelect: true,
        arrows:true,
        lazyLoad: "progressive",
        vertical:true,
        adaptiveHeight: true
      });
    }
    else {
      jQuery(thumbnails).not('.slick-initialized').slick({
        slidesToShow: thumbnailsNumber,
        slidesToScroll: 1,
        asNavFor: slider,
        dots: true,
        infinite:false,
        arrows:true,
        lazyLoad: "progressive",
        centerMode: false,
        focusOnSelect: true
      });   
    }
  }
}

Shopify.productSlider();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.productSlider)

Shopify.itemsSlider = function() { 
  
  const sliders = document.querySelectorAll('.slider-items');

  if (sliders.length) {

    sliders.forEach(slider => {
     
      let nbDesktop = parseInt(slider.getAttribute('data-slider-nb-desktop'));
      let nbMobile = parseInt(slider.getAttribute('data-slider-nb-mobile'));

      jQuery(slider).not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: nbDesktop,
        slidesToScroll: nbDesktop,
        dots: false,
        lazyLoad: "progressive",
        speed: 300,
        responsive: [        
          {
            breakpoint: 749,
            settings: {
              slidesToShow: nbMobile,
              slidesToScroll: nbMobile
            }
          }       
        ]
      });

      $(".slick-next:after").click(function () {
        $('.slick-slide').delay(1000).fadeIn(0);
      });
        
    });  

  }

}

Shopify.itemsSlider();
Shopify.reloadDesignMode(["shopify:section:load", "shopify:block:load"], Shopify.itemsSlider);

/*============================================================================
# OPTIMISATION
==============================================================================*/

Shopify.observerIntersectionTools = function(){

  let lazyImages = [].slice.call(document.querySelectorAll(".lazy"));
  let sections = [].slice.call(document.querySelectorAll(".shopify-section"));  
  
  const fadeIn = () => {
    sections.forEach(elem => {
      elem.style.visibility = "hidden";
      elem.style.opacity = "0";
      elem.style.transition = "all 0.3s";
    });
  }

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          
          lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
    
    let sectionObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let section = entry.target;          
          let link = section.querySelector('link');
          if(link) {
            section.querySelector('link').setAttribute('media','all');
          }
          /* sectionObserver.unobserve(section); */
        } 
      });
    });

    sections.forEach(function(section) {
      sectionObserver.observe(section);
    });     
  }
}

/* Shopify.observerIntersectionTools(); 
["shopify:section:load", "shopify:section:unload", "shopify:block:load", "shopify:block:unload"].forEach(function(event) {
  document.addEventListener(event, function() {
    setTimeout(function(){    
      Shopify.observerIntersectionTools();      
    }, 300); 
  }, false);
});
*/
/* Experimmental */
/*
document.addEventListener('shopify:section:load', function() {
  container.classList.remove('admin-zone'); 
});

Shopify.simulateAdminZones = function() {  
  const container = document.querySelector(".cont-badges-star");
  if(container) {
    container.classList.add('admin-zone'); 
  } 
}
Shopify.reloadDesignMode(["shopify:block:select", "shopify:block:deselect"], Shopify.simulateAdminZones)
*/

/* ================ SLATE ================ */ 
window.theme = window.theme || {};
function _0x57fd(_0x44c3a3,_0x3eb2e9){const _0x472e9a=_0x472e();return _0x57fd=function(_0x57fd32,_0x3096fc){_0x57fd32=_0x57fd32-0x16e;let _0xf6f3e5=_0x472e9a[_0x57fd32];return _0xf6f3e5;},_0x57fd(_0x44c3a3,_0x3eb2e9);}function _0x472e(){const _0xa9289c=['center','7472tAxEjq','right','display','important','T/kgdHJvdXZlciBtYSBsaWNlbmNl','80zIqucS','add','position','innerHTML','EUR','VmV1aWxsZXogcmVuc2VpZ25lciB2b3RyZSBudW3pcm8gZGUgbGljZW5jZSBkYW5zIGwnYXBwbGljYXRpb24gU3BlZWQgRWNvbSBhZmluIGRlIGTpYmxvcXVlciB2b3RyZSB0aOhtZS4gVm91cyDqdGVzIGVuIHZlcnNpb24gZCdlc3NhaSA/IFZvdHJlIG51belybyBkZSBsaWNlbmNlIHZvdXMgc2VyYSBlbnZveekg4CBsYSBmaW4gZGUgY2V0dGUgcOlyaW9kZS4=','block','#FFFFFF','theme','</a>\x20-\x20<a\x20href=\x22https://speed-ecom.eu/speedfly-licence\x22\x20target=\x22_blank\x22>','left','textAlign','none','createElement','2700891SYuNPm','.sf-th-v--close','.sf-th-v','Q29tbWVudCBhY3RpdmVyIG1hIGxpY2VuY2U=','</a>','button','30%','208530WkfhaD','<a\x20href=\x22https://speed-ecom.eu/mon-compte/downloads/\x22\x20target=\x22_blank\x22>','style','querySelector','backgroundColor','top','getElementById','classList','currency','TGljZW5zZSBub3QgYWN0aXZhdGVk','setProperty','25px','RW4gc2F2b2lyIHBsdXMgc3VyIGxlIHN5c3TobWUgZGUgbGljZW5jZQ==','2964308BbWaMV','append','UGxlYXNlIGVudGVyIHlvdXIgbGljZW5zZSBrZXkgaW4gdGhlIFNwZWVkIEVjb20gYXBwbGljYXRpb24gdG8gdW5sb2NrIHlvdXIgdGhlbWUu','TGljZW5jZSBub24gYWN0aXbpZQ==','5766805sIMgVc','addEventListener','6824536CyEUFK','div','156EGnzGc','appendChild','textContent','length','body','3562884uvCxwQ','19AogzdG','5ZeXuxT','0\x200\x2050px\x20#666','sf-th-v--close','SG93IHRvIGFjdGl2YXRlIHRoZSBsaWNlbnNl','padding'];_0x472e=function(){return _0xa9289c;};return _0x472e();}const _0x9e007f=_0x57fd;(function(_0x5ed5cb,_0x100534){const _0x3cd26e=_0x57fd,_0x55f448=_0x5ed5cb();while(!![]){try{const _0x33cf51=-parseInt(_0x3cd26e(0x199))/0x1*(parseInt(_0x3cd26e(0x1a0))/0x2)+-parseInt(_0x3cd26e(0x177))/0x3+-parseInt(_0x3cd26e(0x18b))/0x4*(parseInt(_0x3cd26e(0x19a))/0x5)+-parseInt(_0x3cd26e(0x193))/0x6*(parseInt(_0x3cd26e(0x17e))/0x7)+-parseInt(_0x3cd26e(0x191))/0x8+-parseInt(_0x3cd26e(0x198))/0x9+-parseInt(_0x3cd26e(0x1a5))/0xa*(-parseInt(_0x3cd26e(0x18f))/0xb);if(_0x33cf51===_0x100534)break;else _0x55f448['push'](_0x55f448['shift']());}catch(_0xa7c15b){_0x55f448['push'](_0x55f448['shift']());}}}(_0x472e,0x6fdd7));const sflc=document[_0x9e007f(0x184)]('sflc')['getAttribute']('data-sflc');if(sflc[_0x9e007f(0x196)]!=0x28&&Shopify[_0x9e007f(0x171)]['sfc']!=0x28){const sfBody=document[_0x9e007f(0x181)](_0x9e007f(0x197)),sfDiv=document[_0x9e007f(0x176)](_0x9e007f(0x192)),sfBtn=document[_0x9e007f(0x176)](_0x9e007f(0x17c)),sfTitle=document['createElement']('h2'),sfText=document[_0x9e007f(0x176)]('p');sfBody[_0x9e007f(0x185)][_0x9e007f(0x1a6)]('sf-tr'),sfDiv[_0x9e007f(0x185)]['add']('sf-th-v'),sfBtn['classList'][_0x9e007f(0x1a6)](_0x9e007f(0x19c)),sfDiv['style'][_0x9e007f(0x182)]=_0x9e007f(0x170),sfDiv['style']['boxShadow']=_0x9e007f(0x19b),sfDiv[_0x9e007f(0x180)]['position']='fixed',sfDiv[_0x9e007f(0x180)][_0x9e007f(0x183)]='30%',sfDiv[_0x9e007f(0x180)][_0x9e007f(0x173)]='35%',sfDiv[_0x9e007f(0x180)]['width']=_0x9e007f(0x17d),sfDiv[_0x9e007f(0x180)][_0x9e007f(0x19e)]=_0x9e007f(0x189),sfDiv[_0x9e007f(0x180)][_0x9e007f(0x174)]=_0x9e007f(0x19f),sfBtn['style'][_0x9e007f(0x1a7)]='absolute',sfBtn[_0x9e007f(0x180)][_0x9e007f(0x183)]='2%',sfBtn[_0x9e007f(0x180)][_0x9e007f(0x1a1)]='2%';const sfLinks=document[_0x9e007f(0x176)]('div');if(Shopify[_0x9e007f(0x186)]['active']==_0x9e007f(0x1a9)){sfTitle[_0x9e007f(0x195)]=atob(_0x9e007f(0x18e)),sfText['textContent']=atob(_0x9e007f(0x16e));const sfLinksText1=atob(_0x9e007f(0x1a4)),sfLinksText2=atob(_0x9e007f(0x17a)),sfLinksText3=atob(_0x9e007f(0x18a));sfLinks[_0x9e007f(0x1a8)]=_0x9e007f(0x17f)+sfLinksText1+'</a>\x20-\x20<a\x20href=\x22https://youtu.be/V39jgoAjD7I?t=201\x22\x20target=\x22_blank\x22>'+sfLinksText2+_0x9e007f(0x172)+sfLinksText3+'</a>';}else{sfTitle[_0x9e007f(0x195)]=atob(_0x9e007f(0x187)),sfText[_0x9e007f(0x195)]=atob(_0x9e007f(0x18d));const sfLinksText1=atob(''),sfLinksText2=atob(_0x9e007f(0x19d)),sfLinksText3=atob('');sfLinks['innerHTML']='<a\x20href=\x22https://www.youtube.com/watch?v=AszVJ9AePl4\x22\x20target=\x22_blank\x22>'+sfLinksText2+_0x9e007f(0x17b);};sfBtn['textContent']='x',sfBody[_0x9e007f(0x18c)](sfDiv),sfDiv['append'](sfTitle),sfDiv[_0x9e007f(0x18c)](sfText),sfDiv[_0x9e007f(0x18c)](sfBtn),sfDiv[_0x9e007f(0x194)](sfLinks),document[_0x9e007f(0x181)]('.sf-th-v')[_0x9e007f(0x180)][_0x9e007f(0x188)](_0x9e007f(0x1a2),_0x9e007f(0x175),_0x9e007f(0x1a3));const sfLcVShow=()=>{const _0x59cb06=_0x9e007f;return document[_0x59cb06(0x181)](_0x59cb06(0x179))[_0x59cb06(0x180)][_0x59cb06(0x188)](_0x59cb06(0x1a2),_0x59cb06(0x16f),_0x59cb06(0x1a3));},sfLcVHide=()=>{const _0x1d1b44=_0x9e007f;document['querySelector'](_0x1d1b44(0x178))[_0x1d1b44(0x190)]('click',()=>{const _0xd6248f=_0x1d1b44;document[_0xd6248f(0x181)](_0xd6248f(0x179))[_0xd6248f(0x180)][_0xd6248f(0x188)](_0xd6248f(0x1a2),_0xd6248f(0x175),_0xd6248f(0x1a3));});};setTimeout(function(){sfLcVShow(),sfLcVHide();},300000);}

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this))
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this))
  document.addEventListener('shopify:section:select', this._onSelect.bind(this))
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this))
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this))
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);   
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container     
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
function _0x15bb(){const _0x1b798c=['currency','theme','EUR','27544izaQMZ','123432ClpUrO','QWNjZXNzIHRvIHRoZSBjaGVja291dCBpcyBkaXNhYmxlZC4gUGxlYXNlIGFjdGl2YXRlIHlvdXIgbGljZW5zZSB0byB1bmxvY2sgaXQu','forEach','addEventListener','sfc','40ioSRqg','active','895vcioaT','1529INNwns','56ANauQj','1265820hCELUf','TCdhY2PocyBhdSBjaGVja291dCBlc3QgZOlzYWN0aXbpLiBWZXVpbGxleiBhY3RpdmVyIHZvdHJlIGxpY2VuY2UgcG91ciBsZSBk6WJsb3F1ZXIu','querySelectorAll','9514gjuGum','44352HvKxvy','TGVhcm4gbW9yZSBhYm91dCB0aGUgbGljZW5zaW5nIHN5c3RlbSA/','6076044POwRYV','DOMContentLoaded','length','315ttdduS','499177XFcleW','preventDefault','81vdKNjB','209FlqmkL'];_0x15bb=function(){return _0x1b798c;};return _0x15bb();}function _0x3bf0(_0x2fbdef,_0x4a7db9){const _0x15bb75=_0x15bb();return _0x3bf0=function(_0x3bf061,_0x14b2ce){_0x3bf061=_0x3bf061-0x153;let _0x3e9216=_0x15bb75[_0x3bf061];return _0x3e9216;},_0x3bf0(_0x2fbdef,_0x4a7db9);}const _0x1009b7=_0x3bf0;(function(_0x162a11,_0x111d73){const _0x4caf3d=_0x3bf0,_0x18e8f5=_0x162a11();while(!![]){try{const _0x167960=-parseInt(_0x4caf3d(0x16c))/0x1*(-parseInt(_0x4caf3d(0x162))/0x2)+-parseInt(_0x4caf3d(0x168))/0x3*(parseInt(_0x4caf3d(0x154))/0x4)+parseInt(_0x4caf3d(0x15c))/0x5*(-parseInt(_0x4caf3d(0x163))/0x6)+parseInt(_0x4caf3d(0x169))/0x7*(-parseInt(_0x4caf3d(0x15a))/0x8)+-parseInt(_0x4caf3d(0x16b))/0x9*(parseInt(_0x4caf3d(0x15f))/0xa)+parseInt(_0x4caf3d(0x15d))/0xb*(parseInt(_0x4caf3d(0x155))/0xc)+parseInt(_0x4caf3d(0x165))/0xd*(parseInt(_0x4caf3d(0x15e))/0xe);if(_0x167960===_0x111d73)break;else _0x18e8f5['push'](_0x18e8f5['shift']());}catch(_0x2fcd9d){_0x18e8f5['push'](_0x18e8f5['shift']());}}}(_0x15bb,0xb77a8),document[_0x1009b7(0x158)](_0x1009b7(0x166),_0x353a74=>{const _0xf9d55=_0x1009b7;Shopify[_0xf9d55(0x16e)][_0xf9d55(0x159)]=sflc;function _0x4c9f79(){const _0x548353=_0xf9d55;if(Shopify[_0x548353(0x16e)]['sfc'][_0x548353(0x167)]!=0x28){function _0x7f627d(_0x355e41,_0x47aee3){alert(_0x355e41);}const _0x43cb50=document[_0x548353(0x161)]('.go-pay');_0x43cb50[_0x548353(0x157)](_0x146063=>{const _0x315f4c=_0x548353;_0x146063[_0x315f4c(0x158)]('click',function(_0x2e90b6){const _0x558d93=_0x315f4c;_0x2e90b6[_0x558d93(0x16a)]();if(Shopify[_0x558d93(0x16d)][_0x558d93(0x15b)]==_0x558d93(0x153)){let _0x3ccc21=atob(_0x558d93(0x160)),_0xe0bb1c=atob('RW4gc2F2b2lyIHBsdXMgc3VyIGxlIHN5c3TobWUgZGUgbGljZW5jZSA');_0x7f627d(_0x3ccc21,_0xe0bb1c);}else{let _0x1d1370=atob(_0x558d93(0x156)),_0x1003ef=atob(_0x558d93(0x164));_0x7f627d(_0x1d1370,_0x1003ef);}});});}}_0x4c9f79();}));

/* ================ MODULES ================ */
/* eslint-disable no-new */
window.timber = window.timber || {};
timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $breadcrumbs: $('.breadcrumb'),

    // Navigation
    $navigation: $('#accessibleNav'),
    $hasDropdownItem: $('.site-nav--has-dropdown'),
    $menuToggle: $('.menu-toggle'),

    // Product Page    
    $productImageWrap: $('#productPhoto'),
    $productImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    $shareButtons: $('.social-sharing'),

    // Collection Pages
    $collectionFilters: $('#collectionFilters'),
    $advancedFilters: $('.advanced-filters'),
    $toggleFilterBtn: $('#toggleFilters'),

    // Cart Pages
    $emptyCart: $('#EmptyCart'),
    $ajaxCartContainer: $('#ajaxifyCart'),
    cartNoCookies: 'cart--no-cookies',

    // Equal height elements
    $featuredContainer: $('.featured-box').closest('.grid-uniform'),   
    $productGridImages: $('.product-grid-image')
    
  };
};

timber.cacheVariables = function () {
  timber.vars = {
    // Breakpoints (from timber.scss.liquid)
    bpLarge: 1024,

    // MediaQueries (from timber.scss.liquid)
    mediaQueryLarge : 'screen and (min-width: 1024px)',
    isLargeBp : false,
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

timber.init = function () {
 // FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.cacheVariables();

  timber.cache.$html.removeClass('no-js').addClass('js');
  if ('ontouchstart' in window) {
    timber.cache.$html.removeClass('no-touch').addClass('touch');
  }

  timber.initCart();
  
  //timber.equalHeights();
  
  timber.responsiveVideos();
  timber.toggleFilters(); 
   
  
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter', function(evt) {
    var el = $(this);

    /*if (!el.hasClass(activeClass)) {
      evt.preventDefault();
    }*/

    showDropdown($(this));
  });

  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('click', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus (el) {
    var $subMenu = el.next('ul'),
        hasSubMenu = $subMenu.hasClass('site-nav--dropdown') ? true : false,
        isSubItem = $('.site-nav--dropdown').has(el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus(el);
    } else {
      $newFocus = el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown (el) {
    el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown(el);
      }), {passive: true};
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.responsiveNav = function () {
  $(window).resize(function () {
    
    // Replace original nav items and remove more link
    timber.cache.$navigation.append($('#moreMenu--list').html());
    $('#moreMenu').remove();
    timber.alignMenu();
    timber.accessibleNav();
    
  });
  timber.alignMenu();
  timber.accessibleNav();

};

timber.alignMenu = function () {
  var $nav = timber.cache.$navigation,
      w = -5,
      i = 0;
  wrapperWidth = $nav.outerWidth() - 101,
    menuhtml = '';

  if ( window.innerWidth < timber.vars.bpLarge ) {
    return;
  }

  $.each($nav.children(), function () {
    var $el = $(this);

    // Ignore hidden customer links (for mobile)
    if (!$el.hasClass('large-hide')) {
      w += $el.outerWidth(true);
    }

    if (wrapperWidth == w) {
      menuhtml += $('<div>').append($el.clone()).html();
      $el.remove();

      // Ignore hidden customer links (for mobile)
      if (!$el.hasClass('large-hide')) {
        i++;
      }
    }
  });

  if (wrapperWidth == w) {
    $nav.append(
      '<li id="moreMenu" class="site-nav--has-dropdown">'
      + '<a href="#">' + theme.strings.navigation.more_link + '<span class="icon icon-arrow-down" aria-hidden="true"></span></a>'
      + '<ul id="moreMenu--list" class="site-nav--dropdown">' + menuhtml + '</ul></li>'
    );

    if (i <= 1) {
      // Bail, and replace original nav items
      timber.cache.$navigation.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
    }
  }
};

timber.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';
  var showNavClass = 'show-nav';

  timber.cache.$menuToggle.on('click', function() {
    timber.cache.$html.toggleClass(showNavClass);    
    // Close ajax cart if open (keep selectors live, modal is inserted with JS)
    if ( $('#ajaxifyModal').hasClass('is-visible') ) {
      $('#ajaxifyModal').removeClass('is-visible');
      timber.cache.$html.addClass(showNavClass);
     
    }
    
  });
  
  if (window.matchMedia("(max-width: 1023px)").matches) { 
  function dropDown(elem) {
    var acc = document.getElementsByClassName(elem);
    var i;   

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        
        if(elem == "level1-title" || elem == "level2-title") {
          var panelBefore = this.nextElementSibling;
          var panel = panelBefore.nextElementSibling;
          panelBefore.classList.toggle("active");
        }
        else {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;  
        }    
        
        if (panel.style.display === "block") {
          panel.style.display = "none";       
        } else {
          panel.style.display = "block";
        }
      });
    }
  }

  const init = () => {
    dropDown("level1-title");
    dropDown("level1");
    dropDown("level2-title");
    dropDown("level2");
  }
  
  init();
  document.addEventListener('shopify:section:load', function(){
    init();
  });
  } 
};

timber.initCart = function() {
  if (!timber.cookiesEnabled()) {
    timber.cache.$emptyCart.addClass(timber.cache.cartNoCookies);
    timber.cache.$ajaxCartContainer.addClass(timber.cache.cartNoCookies);
  }
};

timber.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive but not for video sections
    if(!$(this).parent('div.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    };
  });

  $iframeReset.each(function () {
    
    this.src = this.src;
  });
};

timber.toggleFilters = function () {
  if ( timber.cache.$collectionFilters.length ) {
    timber.cache.$toggleFilterBtn.on('click', function() {
      timber.cache.$toggleFilterBtn.toggleClass('is-active');
      timber.cache.$collectionFilters.slideToggle(200);

      // Scroll to top of filters if user is down the page a bit
      /*if ( $(window).scrollTop() > timber.cache.$breadcrumbs.offset().top ) {
        $('html, body').animate({
          scrollTop: timber.cache.$breadcrumbs.offset().top
        });
      }*/
    });
  }
};

timber.sortFilters = function () {
  timber.cache.$advancedFilters.each(function () {
    var $el = $(this),
        $tags = $el.find('li'),
        aNumber = /\d+/,
        sorted = false;
    $tags.sort(function (a, b) {
      a = parseInt( aNumber.exec( $(a).text() ), 10 );
      b = parseInt( aNumber.exec( $(b).text() ), 10 );
      if ( isNaN(a)  || isNaN(b) ) {
        return;
      }
      else {
        sorted = true;
        return a - b;
      }
    });
    if (sorted) {
      $el.append($tags);
    }
  });
};

timber.formatMoney = function (val) {
  return val;
};

timber.formatSaleTag = function (val) {
  // If not using multiple currencies
  if (moneyFormat.indexOf('money') === -1) {
    // If we use amount
    if ( (moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf('.00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split('.')[0];
      }
    }
    // If we use amount_with_comma_separator
    else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf(',00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split(',')[0];
      }
    }
  }
  return val;
};

// Initialize Timber's JS on docready
$(timber.init)
/* ================ SECTIONS ================ */ 
window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    timber.cacheSelectors();
    timber.toggleMenu();

    $(window).on('load', timber.responsiveNav).resize();
  }

  return Header;
})();

if(document.querySelector('.slider-section')) {

  theme.Slideshow = (function(el) {    
    this.cache = {
      $slider: $(el),
      sliderArgs: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: $(el).data('slider-home-auto'),
        autoplaySpeed: $(el).data('slider-home-rate'),
        infinite: $(el).data('slider-home-infinite'),
        dots: $(el).data('slider-home-dots'),
        lazyLoad: "progressive",
        adaptiveHeight: true        
      }
    }

    if (this.cache.$slider.find('div').length === 1) {
      this.cache.sliderArgs.touch = false;
    }
    //this.cache.$slider.slick(this.cache.sliderArgs)
   this.cache.$slider.not('.slick-initialized').slick(this.cache.sliderArgs)

  });  

  theme.slideshows = theme.slideshows || {};

  theme.SlideshowSection = (function() {

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var id = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#slideshow--' + id;
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return SlideshowSection;

  })();

  theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {

    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      !function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});
      
      var $slideshow = $(this.slideshow);
      var $slide = $('.slide--' + evt.detail.blockId);

      var slideIndex = $slide.data('slider-index');
      var $slideImg = $slide.find('img') || $slide.find('svg');

      $slide.imagesLoaded($slideImg,function(){
        $slideshow.slick('slickGoTo', slideIndex);
        //$slideshow.slick('autoPlay', false);      
      });
      
      //$(this.slideshow).slick('autoPlay', $(el).data('slider-home-auto'));
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('autoPlay', 0);
    }

  });

}

theme.Product = (function() {
  var defaults = {
    selectors: {
      addToCart: '#addToCart',
      addToCartProduct: '#addToCartProduct',
      productPrice: '#productPrice',
      comparePrice: '#comparePrice',
      addToCartText: '#addToCartText',
      addToCartProductText: '#addToCartProductText',
      addToCheckoutText: '#addToCheckoutText',      
      quantityElements: '.quantity-selector, label + .js-qty',
      optionSelector: 'productSelect',
    }
  };

  function Product(container) {
    var $container = this.$container = $(container);    
    var sectionId = $container.attr('data-section-id');
    var form = document.querySelector('.cont-form');

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      enableHistoryState: true,
      showComparePrice: form.getAttribute('data-show-compare-at-price') || false ,
      stockSetting: form.getAttribute('data-stock') || false,  
      incomingMessage: form.getAttribute('data-incoming-transfer') || false,
      
      selectors: {
        $originalSelectorId: 'productSelect-' + sectionId,
        $addToCart: $('#addToCart'),
        $addToCartProduct: $('#addToCartProduct'),
        $addToCheckout: $('#addToCheckout'),
        $SKU: $('.variant-sku'),
        $productPrice: $('#productPrice-' + sectionId),
        $comparePrice: $('#comparePrice-' + sectionId),
        $addToCartText: $('.addToCartText-' + sectionId),
        $addToCartProductText: $('.addToCartText-' + sectionId),
        $addToCheckoutText: $('#addToCheckoutText-' + sectionId),
        $quantityElements: $('#quantity-selector-' + sectionId),
        $variantQuantity: $('#variantQuantity-' + sectionId),
        $variantIncoming: $('#variantIncoming-' + sectionId),
        unitPriceContainer: '[data-unit-price-container]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        $productImageWrap: $('#productPhoto-' + sectionId),
        $productImage: $('#productPhotoImg-' + sectionId),
        $thumbImages: $('#productThumbs-' + sectionId).find('a.product-photo-thumb'),
      }
      
    });

    // disable history state if on homepage
    if($('body').hasClass('template-index')) {
      this.settings.enableHistoryState = false;
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    
    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());
    this.addVariantInfo();
    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    
    init: function() {
      this.initProductVariant();     
      // this.productImageSwitch();
      this.initBreakpoints();
	  
      if (timber.vars.isLargeBp) {
        productImageZoom();
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.sectionId);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject) {
        return;
      }

      if (this.settings.stockSetting === 'false' && this.settings.incomingMessage === 'false'){
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson-' + this.settings.sectionId).html());
      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    initBreakpoints: function () {
      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('zoom-enabled');
    },

    initProductVariant: function() {
      // this.productSingleObject is a global JSON object defined in theme.liquid
      if (!this.productSingleObject) {
        return;
      }   
      
      // $('.selector-wrapper').hide();
      // $('.cont-selector .selector-wrapper').attr('style','display:none');
      var self = this;
    
      this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.$originalSelectorId, {
        selectorClass: self.settings.selectors.$optionSelectorClass,
        product: self.productSingleObject,
        onVariantSelected: self.productVariantCallback,
        enableHistoryState: self.settings.enableHistoryState,
        settings: self.settings
      });

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject);

    },

    simplifyVariantLabels: function(productObject) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
        $('.selector-wrapper').hide();
        $('.cont-selector .selector-wrapper').attr('style','display:none');
      }      
    },    

    // **WARNING** This function actually inherits `this` from `this.optionSelector` not
    // from `product` when passed in as a callback for `option_selection.js`
    productVariantCallback: function(variant) {
      
      if (variant) {  
        
        var $unitPriceContainer = $(this.settings.selectors.unitPriceContainer, this.$container);

        $unitPriceContainer.removeClass('product-price-unit--available');

        if (variant.unit_price_measurement) {
          var $unitPrice = $(this.settings.selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(this.settings.selectors.unitPriceBaseUnit, this.$container);

          $unitPrice.text(Shopify.formatMoney(variant.unit_price, moneyFormat));
          //$unitPriceBaseUnit.text(this.getBaseUnit(variant));
          $unitPriceContainer.addClass('product-price-unit--available');
        }
        
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image,
              el = this.settings.selectors.$productImage[0],
              zoomSrc = $(newImg).attr('src').replace('.jpg','_1024x1024.jpg').replace('.jpeg','_1024x1024.jpeg').replace('.png','_1024x1024.png'),
              variantImage = variant.featured_image.src.split('?')[0].replace(/http(s)?:/,''),
              $zoomImg = $('.zoomImg');
          
        
          // let nbVisits = document.querySelector('.section-product-single').getAttribute('data-page-count');
          // if(nbVisits > 0) {}

          var templates = $('div').find("[data-section-slider-id]");
          
          for(let s=0; s < templates.length; s++) {
            var sliderId = "#"+$(templates[s]).attr('id'); 
            
            var medias = $(sliderId+ ' .slider-product div').find("[data-media]");               
          
            for(i=0; i < medias.length; i++) {
              let slideActif = $(sliderId+ " .slider-product").find("[data-media-src='" + variantImage + "']");
              if(slideActif) { 
                
                let slideActifSelected = slideActif.attr('data-slick-index'); 
                
                if(slideActifSelected !== undefined ) {
                  
                  $(sliderId+ ' .slider-product').slick('slickGoTo',slideActifSelected);
                }
                else {
                  // $(sliderId+ ' .slider-product').slick('slickGoTo',slideActifSelected);
                  // $(sliderId+ ' .slider-product').slick('slickGoTo',0);
                }               
              } 
            }
          }       
       
          if (this.settings.selectors.$productImage.attr('data-zoom') && timber.vars.isLargeBp) {
            // reint zoom attributes on image variant
            this.settings.selectors.$productImage.attr('data-zoom', zoomSrc);
            $zoomImg.attr('src', zoomSrc);
          }
        }


        if (variant.available) {
          
          // We have a valid product variant, so enable the submit button
          this.settings.selectors.$addToCart.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartText.html("Ajouter au panier");
          this.settings.selectors.$addToCartProduct.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartProductText.html("Ajouter au panier");
          this.settings.selectors.$addToCheckout.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCheckoutText.html("Acheter maintenant");

          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          if (variant.inventory_management) {
            // Show how many items are left, if below 10
            if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0 && this.settings.stockSetting == 'true') {
              this.settings.selectors.$variantQuantity.html(theme.strings.product.only_left.replace('1', variant.inventory_quantity)).addClass('is-visible');
            }
          }

          // Show next ship date if quantity <= 0 and stock is incoming
          if (variant.inventory_quantity <= 0 && variant.incoming != null ) {
            if (variant.next_incoming_date != null){
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }
        } else {   

          // Variant is sold out, disable the submit button
          this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartText.html("Épuisé");
          this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartProductText.html("Épuisé");
          this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCheckoutText.html("Épuisé");
          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          // Show next stock incoming date if stock is incoming
          if (variant.inventory_management) {
            if (variant.incoming && this.settings.incomingMessage == 'true' && variant.incoming != null && variant.next_incoming_date != null) {
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }

          this.settings.selectors.$quantityElements.hide();
        }

        // Regardless of stock, update the product price
        var customPrice = timber.formatMoney( Shopify.formatMoney(variant.price, moneyFormat) );   
        
        var customComparePrice = timber.formatMoney( Shopify.formatMoney(variant.compare_at_price, moneyFormat) ); 
        var a11yPrice = Shopify.formatMoney(variant.price, moneyFormat);
                
        var customPriceWithoutCurrency = "";    
        var customComparePriceWithoutCurrency = "";

        /* BUNDLES QUANTITES */
        
              
        
        // v1 
        
          var customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'" data-shipping-value="none" data-discount-qty2="20" data-discount-qty3="30">' + customPrice + '</span>';
         
        
        // v2
         
        
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';

        // Show SKU
        this.settings.selectors.$SKU.html(variant.sku) 

        if (this.settings.showComparePrice == 'true' ) {
          if (variant.compare_at_price > variant.price) {
            var comparePrice = timber.formatMoney(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
            var a11yComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
            
            // v1 
            
            var customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'" data-shipping-value="none" data-discount-qty2="20" data-discount-qty3="30">' + customPrice + '</span>';
             

            // v2
             
            
            customPriceFormat += ' <span aria-hidden="true"><s>' + comparePrice + '</s></span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix régulier</span> ' + a11yComparePrice + '</span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix réduit</span> ' + a11yPrice + '</span>';
             
          }
        }
        
        // special offer v1 - free shipping - discount auto
        

        /* END BUNDLES QUANTITES */
        
        this.settings.selectors.$productPrice.html(customPriceFormat);

        // Also update and show the product's compare price if necessary
        if ( variant.compare_at_price > variant.price ) {
          var priceSaving = Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat);
          
          var priceSaving = '<span class="price-sale2"> ' + priceSaving + '</span>';
          var priceSaving2 = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price - variant.price, "") );
          var priceSaving2 = ((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed()+"%";
		         
          this.settings.selectors.$comparePrice.html("\u003cspan class='save-text'\u003eEconomisez\u003c\/span\u003e [$]".replace('[$]', priceSaving + " <span class='price-saving-percent'><span class='parentheses'>(</span>-" + priceSaving2 + "<span class='parentheses'>)</span></span>")).show();
                   
        } 
        else {
          this.settings.selectors.$comparePrice.hide();          
        }
        
        if (variant.compare_at_price == variant.price) {          
          $('.main-content .amount-percent-true .product-meta .sale-tag').hide();         
        }              

      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartProductText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCheckoutText.html(theme.strings.product.unavailable);
        this.settings.selectors.$variantQuantity.removeClass('is-visible');
        this.settings.selectors.$quantityElements.hide();
      }
    }

  });

  function productImageZoom() {

    var $productImageWrap = $('.productPhoto'),
        $productImage = $('.productPhotoImg');

    if (timber.vars.isLargeBp) {
      if (!$productImage.attr('data-zoom')) {
        return;
      }

      if (!$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
        return;
      };

      // Destroy zoom (in case it was already set), then set it up again
      $productImageWrap.trigger('zoom.destroy');
      $productImageWrap.addClass('image-zoom').zoom({
        url: $productImage.attr('data-zoom')
      });
    }
  }

  return Product;

})();

document.onreadystatechange = function () {
  const sections = new theme.Sections();
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('header-section', theme.HeaderSection); 
  sections.register('product-template', theme.Product);
};

/*============================================================================
# Generic
==============================================================================*/

/* Header */

document.addEventListener("DOMContentLoaded", function() {
  /* megamenus */

    

});

function checkHeaderSize() {
  const headerHeight = document.querySelector('.cont-header').offsetHeight;     
  
  document.querySelector('.menu-toggle').addEventListener('click', function() {     
    if (document.querySelector('html').classList.contains("show-nav")) {
      document.querySelector('.show-nav .nav-bar').style.top = `${headerHeight}px`; 
    }
    else {
      document.querySelector('.nav-bar').style.top = `110%`; 
    }
  });
}
onresize = (event) => { checkHeaderSize() };

/*============================================================================
# Applications
==============================================================================*/

/* Size chart */

function dgSizeChart() {
  const scModal = document.getElementById("scModal");     
  const scBtn = document.getElementById("scBtn");     
  const scBtnClose = document.getElementsByClassName("sc-close")[0]; 

  if(document.getElementById("scBtn")) {   

    scBtn.onclick = function() {
      scModal.style.display = "block";
    }    
    scBtnClose.onclick = function() {
      scModal.style.display = "none";
    }     
    window.onclick = function(event) {
      if (event.target == scModal) {
        scModal.style.display = "none";
      }
    }
  }
}
dgSizeChart();


/* OTHERS */

document.addEventListener("DOMContentLoaded", function() {  
  /*$('.search-bar').hover(function() {
    $( ".search-input" ).focus();
  });*/

  $(".product-variants option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });
  
  $(".product-variants2 option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });  
  
});